'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var ConfigurationHostShareController = function ConfigurationHostShareController($scope, $q, $log, dataRetrieverService, configurationHostShareService, hepService, featureToggleService, configurationService, globalNotificationsDataService) {
  dataRetrieverService.getDataRetriever('SYSTEM_STATUS_SCREEN', 'configuration-host-share-mode').setCustomSearchCriteriaRules([]);
  var CONFLICT_ERROR_CODE = 409;
  var reloadHostShare = hepService.loadHostShare;
  var fieldsToExport = ['origin', 'destination', 'month', 'dayOfWeek', 'hostShare'];
  var fieldsToExportSPOS = ['origin', 'destination', 'significantPOS', 'month', 'dayOfWeek', 'hostShare'];
  var npsFields = ['hostShareNew', 'diff', 'scenarioName'];
  $scope.data = createImportModalData();
  $scope.tooltipLabel = 'Host Share Options';
  $scope.statusScenarioEventName = 'host-share-tooltip';
  $scope.hostShareUpdates = {
    'content': 'Host Share Updates available'
  };
  $scope.isHostShareEnabled = featureToggleService.isEnabled('NPS_HOST_SHARE');
  function postColumnsErrorHandler(response) {
    if (response.status === CONFLICT_ERROR_CODE) {
      $log.error('ConfigurationHostShareController: postColumnsErrorHandler - Duplicate record exists');
      toastr.error('Duplicated records exist.<br>Please correct data before saving.');
    } else {
      var errorMsg = 'Error when saving configuration changes. ' + response.statusText + ' (code ' + response.status + ')';
      $log.error('ConfigurationHostShareController: postColumnsErrorHandler - ' + errorMsg);
      toastr.error(errorMsg);
    }
    return $q.reject();
  }
  $scope.customDuplicate = function (oldRow) {
    return _.omit(oldRow, 'hepKey');
  };
  $scope.isTooltip = function () {
    globalNotificationsDataService.getTotalAlertsNumber().then(function (data) {
      if (data > 0) {
        $scope.showToolTip = true;
      }
    });
  };
  function validateRow(row) {
    if (row.hasOwnProperty('origin') === false) {
      return '\'Origin\' can not be empty.';
    }
    if (row.hasOwnProperty('destination') === false) {
      return '\'Destination\' can not be empty.';
    }
    if (featureToggleService.isEnabled('SPOS') && row.hasOwnProperty('significantPOS') === false) {
      return '\'POS\' can not be empty.';
    }
    if (row.hasOwnProperty('hostShare') === false) {
      return '\'Host Share\' can not be empty.';
    } else if (parseInt(row.hostShare) < 0 || parseInt(row.hostShare) > 100) {
      return '\'Host Share\' value should be between 0 and 100.';
    }
    if (row.hasOwnProperty('month')) {
      var month = parseInt(row.month);
      if (row.month !== '' && _.isNaN(month) || month < 1 || month > 12) {
        return '\'Month\' value should be between 1 and 12.';
      }
    }
    if (!configurationService.isNonCodeShareMarket(row)) {
      return 'You can\'t save Code Share Market.';
    }
    return '';
  }
  function createImportModalData() {
    return [{
      isSubModalMessage: true,
      type: featureToggleService.isEnabled('NPS_HOST_SHARE') ? 'nps' : ''
    }];
  }
  $scope.customErrorMessage = function () {
    return $scope.validationErrorMessage;
  };
  $scope.customSaveValidation = function (rows) {
    $scope.validationErrorMessage = '';
    _.forEach(rows, function (row) {
      $scope.validationErrorMessage = validateRow(row);
      if (!_.isEmpty($scope.validationErrorMessage)) {
        return false;
      }
    });
    return _.isEmpty($scope.validationErrorMessage);
  };
  $scope.customRemove = function (rowsToBeRemoved) {
    return configurationHostShareService.remove(rowsToBeRemoved)["catch"](postColumnsErrorHandler).then(reloadHostShare);
  };
  $scope.customSave = function (rows) {
    return configurationHostShareService.save(rows)["catch"](postColumnsErrorHandler).then(reloadHostShare);
  };
  $scope.makeExportToCsv = function (data) {
    if (!data.length) {
      toastr.warning('Nothing to export');
      return;
    }
    var fields = featureToggleService.isEnabled('SPOS') ? fieldsToExportSPOS : fieldsToExport;
    fields = featureToggleService.isEnabled('NPS_HOST_SHARE') ? _.concat(fields, npsFields) : fields;
    configurationHostShareService.exportToCsv(data, fields);
  };
  $scope.$on('configuration-host-share:navigation-from-global', function (event) {
    $scope.tooltipLabel = 'Host Share update available';
  });
  $scope.isTooltip();
};
ConfigurationHostShareController.$inject = ['$scope', '$q', '$log', 'DataRetrieverService', 'ConfigurationHostShareService', 'HepService', 'FeatureToggleService', 'ConfigurationService', 'GlobalNotificationsDataService'];
module.exports = ConfigurationHostShareController;